import { Component, OnInit } from '@angular/core';
import { JobInterface, Job } from '@contracts/interfaces/job.interface';
import { JobService } from '../../services/job.service';

@Component({
  selector: 'app-job-tests',
  templateUrl: './job-tests.component.html',
  styleUrls: ['./job-tests.component.scss']
})
export class JobTestsComponent implements OnInit {

  constructor(private jobService: JobService) { }

  jobs: JobInterface[] = [];

  ngOnInit(): void {
    this.reload();
  }

  reload () {
    this.jobService.find({group: "test"}).subscribe((jobs: any[]) => {
        this.jobs = jobs;
    })
  }

  createConsoleLogJob() {
      this.jobService.create({
          job: Job.CONSOLELOG,
          date: {
              start: new Date(),
              // recurring: 10,
              // limit: 5
          },
          data: {
              message: "Test"
          }
      }).subscribe(r => {
        this.reload();
      })
  }

  createEmailJob() {
    this.jobService.create({
        job: Job.EMAIL,
        date: {
            start: new Date(),
            recurring: 5
        },
        data: {
          template: "test",
          to: "darklocker@gmail.com",
          templateVariables: {
            message: "This is a test email"
          }
        }
      }).subscribe((r: any) => {
        this.reload();
      })
  }

  createSMSJob() {
    this.jobService.create({
        job: Job.SMS,
        date: {
            start: new Date()        
        },
        data: {
          template: "google-review",
          to: "+61466040720",
          templateVariables: {
            toName: "Bart Simpson"
          }
        }
      }).subscribe((r: any) => {
        this.reload();
      })
  }

  invoiceReminderJob() {
    this.jobService.create({
      job: Job.INVOICE_REMINDER,
      date: {
          start: new Date()        
      },
      data: {
        invoice: 604
      }
    }).subscribe((r: any) => {
      this.reload();
    });
  }

  bankSyncJob() {
    this.jobService.create({
      job: Job.BANK_SYNC,
      date: {
          start: new Date()        
      },
      data: {}
    }).subscribe((r: any) => {
      this.reload();
    });
  }

  deleteJob(job: JobInterface) {
      this.jobService.delete(job).subscribe(r => {
        this.reload();
      })
  }


}